import React from 'react';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

interface SortableHeaderProps {
  label: string;
  columnKey: string;
  currentSortBy: string;
  currentSortDir: 'asc' | 'desc';
  onSort: (column: string) => void;
  className?: string;
}

export const SortableHeader: React.FC<SortableHeaderProps> = ({
  label,
  columnKey,
  currentSortBy,
  currentSortDir,
  onSort,
  className = '',
}) => {
  const isSorted = currentSortBy === columnKey;

  return (
    <th
      className={`py-2.5 px-4 cursor-pointer hover:bg-slate-100 transition select-none group ${className}`}
      onClick={() => onSort(columnKey)}
    >
      <div className="flex items-center gap-1">
        <span>{label}</span>
        <span className="text-slate-400 group-hover:text-slate-600">
          {!isSorted ? (
            <ArrowUpDown className="w-3.5 h-3.5 opacity-30 group-hover:opacity-100" />
          ) : currentSortDir === 'asc' ? (
            <ArrowUp className="w-3.5 h-3.5 text-sky-600" />
          ) : (
            <ArrowDown className="w-3.5 h-3.5 text-sky-600" />
          )}
        </span>
      </div>
    </th>
  );
};
